"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = PhotoChooser;
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _styles = require("@mui/styles");
var _utils = require("../../utils");
var _ErrorBox = _interopRequireDefault(require("../ErrorBox/ErrorBox"));
var _Button = _interopRequireDefault(require("../Button/Button"));
var _FileChooser = _interopRequireDefault(require("../FileChooser"));
const useStyles = (0, _styles.makeStyles)(theme => ({
  removePhoto: {
    position: 'absolute',
    top: -10,
    right: -10,
    backgroundColor: theme.palette.TwClrBgDanger
  },
  error: {
    width: 'auto',
    marginBottom: theme.spacing(2),
    '&.mobile': {
      width: 'auto'
    }
  },
  thumbnail: {
    margin: 'auto auto',
    objectFit: 'contain',
    display: 'flex',
    maxWidth: '120px',
    maxHeight: '120px'
  }
}));
function PhotoChooser(props) {
  const {
    title,
    description,
    onPhotosChanged,
    multipleSelection,
    error,
    selectedFile,
    uploadText,
    uploadMobileDescription,
    uploadDescription,
    photoSelectedText,
    chooseFileText,
    replaceFileText,
    maxPhotos
  } = props;
  const {
    isMobile
  } = (0, _utils.useDeviceInfo)();
  const classes = useStyles();
  const [files, setFiles] = (0, _react.useState)([]);
  const [filesData, setFilesData] = (0, _react.useState)([]);
  const divRef = (0, _react.useRef)(null);
  const theme = (0, _material.useTheme)();
  const removeFileAtIndex = index => {
    const filesList = [...files];
    filesList.splice(index, 1);
    setFiles(filesList);
  };
  const onChoosingFiles = () => {
    var _divRef$current;
    (_divRef$current = divRef.current) === null || _divRef$current === void 0 ? void 0 : _divRef$current.focus();
  };
  (0, _react.useEffect)(() => {
    const filesDataList = files.map(file => URL.createObjectURL(file));
    setFilesData(filesDataList);
    onPhotosChanged(files);
    return () => {
      // we need to clean this up to avoid a memory leak
      filesDataList.forEach(fileData => URL.revokeObjectURL(fileData));
    };
  }, [files]);
  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    ref: divRef,
    tabIndex: 0,
    sx: {
      backgroundColor: theme.palette.TwClrBg,
      borderRadius: theme.spacing(4),
      padding: theme.spacing(3)
    }
  }, /*#__PURE__*/_react.default.createElement(_material.Box, null, title && /*#__PURE__*/_react.default.createElement(_material.Typography, {
    fontSize: 20,
    fontWeight: 600
  }, title), description && /*#__PURE__*/_react.default.createElement(_material.Typography, {
    fontSize: 14,
    fontWeight: 400,
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2)
  }, Array.isArray(description) ? description.map((txt, i) => /*#__PURE__*/_react.default.createElement("div", {
    key: i
  }, txt)) : description), error && /*#__PURE__*/_react.default.createElement(_ErrorBox.default, {
    title: error.title,
    text: error.text,
    className: classes.error
  }), filesData.length > 0 && multipleSelection && /*#__PURE__*/_react.default.createElement(_material.Box, {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    marginBottom: theme.spacing(2)
  }, filesData.map((fileData, index) => {
    var _files$index;
    return /*#__PURE__*/_react.default.createElement(_material.Box, {
      key: index,
      position: "relative",
      height: 122,
      width: 122,
      marginRight: isMobile ? theme.spacing(2) : theme.spacing(3),
      marginTop: theme.spacing(1),
      border: "1px solid ".concat(theme.palette.TwClrBrdrTertiary)
    }, /*#__PURE__*/_react.default.createElement(_Button.default, {
      icon: "iconTrashCan",
      onClick: () => removeFileAtIndex(index),
      size: "small",
      className: classes.removePhoto
    }), /*#__PURE__*/_react.default.createElement("img", {
      height: "120px",
      src: fileData,
      alt: (_files$index = files[index]) === null || _files$index === void 0 ? void 0 : _files$index.name,
      className: classes.thumbnail
    }));
  }))), /*#__PURE__*/_react.default.createElement(_FileChooser.default, {
    acceptFileType: "image/jpeg,image/png",
    chooseFileText: chooseFileText,
    files: files,
    fileSelectedText: photoSelectedText,
    iconName: "blobbyGrayIconImage",
    maxFiles: maxPhotos,
    multipleSelection: multipleSelection,
    onChoosingFiles: onChoosingFiles,
    replaceFileText: replaceFileText,
    selectedFile: selectedFile,
    setFiles: setFiles,
    uploadDescription: uploadDescription,
    uploadMobileDescription: uploadMobileDescription,
    uploadText: uploadText
  }));
}